<template>
  <div v-if="deletionDate" class="profile-delete-counter">
    <div class="content">
      <p>
        Вы запросили удаление своей анкеты.<br/>Ваша анкета и данные будут удалены во&nbsp;всех&nbsp;наших&nbsp;сервисах.
      </p>

      <p>До удаления анкеты: <b>{{ deletionDate | remainingDays }}</b> </p>
    </div>

    <button
      class="form__submit button button__md button__blue"
      type="button"
      @click.prevent="discardDelete"
    >
      Отменить удаление
    </button>
  </div>
</template>

<script>
export default {
  name: "ProfileDeleteCounter",
  methods: {
    discardDelete() {
      this.$store.dispatch('deletionRecall');
    }
  },
  computed: {
    deletionDate() {
      return this.$store.getters.deletionDate
    }
  }
}
</script>


<style scoped lang="scss">
@import "../../scss/base/mixins.scss";
.profile-delete-counter {
  width: 100%;
  padding: 20px 10px 10px;

  gap: 20px;
  display: flex;
  flex-direction: column;

  text-align: center;

  border-radius: 15px;
  background: #FFF;
  box-shadow: 0 0 50px 0 rgba(0, 30, 79, 0.30);

  @include mobile-min {
    padding: 10px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    text-align: left;
  }

  @include low-desktop-min {
    top: 0;
    right: -20px;
    position: absolute;
    transform: translateX(100%);

    max-width: 330px;
    padding: 20px 10px 10px;
    flex-direction: column;
    text-align: center;
  }

  .content {
    gap: 20px;
    display: flex;
    flex-direction: column;

    @include mobile-min {
      gap: 8px;
    }

    @include low-desktop-min {
      gap: 20px;
    }
  }

  .form__submit {
    height: 46px;
    font-size: 14px;
    line-height: 1;
    padding: 0 10px;

    @include mobile-min {
      max-width: 197px;
    }
  }

  p {
    margin: 0;
    font-size: 14px;
  }

  b {
    display: block;

    @include mobile-min {
      display: inline;
    }
    @include low-desktop-min {
      display: block;
    }
  }
}
</style>
